import React from "react";
import { PORTFOLIO_CATEGORIES } from "@/data/portfolioCategories";

export default function CategoryChips({ active, counts, onChange }) {
  const renderChip = (slug, label, count) => {
    const isActive = active === slug;
    return (
      <button
        key={slug}
        type="button"
        onClick={() => onChange(slug)}
        className={`px-4 py-2 rounded-full text-[12px] uppercase tracking-[0.18em] font-semibold border transition whitespace-nowrap ${
          isActive
            ? "bg-br-bronze border-br-bronze text-white"
            : "bg-white border-gray-200 text-gray-700 hover:border-br-bronze hover:text-br-bronze"
        }`}
        data-testid={`portfolio-chip-${slug}`}
        aria-pressed={isActive}
      >
        {label}
        {typeof count === "number" && (
          <span className={`ml-2 text-[10px] ${isActive ? "text-white/80" : "text-gray-400"}`}>
            {count}
          </span>
        )}
      </button>
    );
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="portfolio-chips">
      {renderChip("all", "All Projects", counts?.all)}
      {PORTFOLIO_CATEGORIES.map((c) => renderChip(c.slug, c.label, counts?.[c.slug]))}
    </div>
  );
}
